__turbopack_context__.v({
  "emptyYet": "index-module-scss-module__sD0yoG__emptyYet",
});
